import { constructFrom as i } from "./constructFrom.js";
import { setMonth as r } from "./setMonth.js";
import { toDate as e } from "./toDate.js";
function l(o, t) {
  let n = e(o);
  return isNaN(+n) ? i(o, NaN) : (t.year != null && n.setFullYear(t.year), t.month != null && (n = r(n, t.month)), t.date != null && n.setDate(t.date), t.hours != null && n.setHours(t.hours), t.minutes != null && n.setMinutes(t.minutes), t.seconds != null && n.setSeconds(t.seconds), t.milliseconds != null && n.setMilliseconds(t.milliseconds), n);
}
export {
  l as default,
  l as set
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/set.js
// module id = 450
// module chunks = 67